import React from 'react';
interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  id?: string;
  tone?: 'light' | 'dark';
}
export function SectionHeading({
  eyebrow,
  title,
  description,
  id,
  tone = 'light'
}: SectionHeadingProps) {
  const isDark = tone === 'dark';
  return <div className="mx-auto flex max-w-3xl flex-col items-center gap-3 text-center" data-id="element-181" data-mp="3jzndka2w3xin">
      {eyebrow && <p className={`text-xs font-bold uppercase tracking-[0.28em] ${isDark ? 'text-gold-bright' : 'text-gold'}`} data-id="element-182" data-mp="bk3oln99519e">
          {eyebrow}
        </p>}
      <h2 id={id} className={`font-display text-3xl md:text-4xl font-bold uppercase leading-tight ${isDark ? 'text-white' : 'text-ink'}`} data-id="element-183" data-mp="1vbylknr4r14">
        {title}
      </h2>
      <span aria-hidden="true" className="h-px w-16 bg-gold-bright" data-id="element-184" data-mp="ui6hid4x7ich" />
      {description && <p className={`text-base md:text-lg leading-relaxed ${isDark ? 'text-white/80' : 'text-ink-muted'}`} data-id="element-185" data-mp="zbishkgofqmr">
          {description}
        </p>}
    </div>;
}